import React, { useMemo, useState } from 'react';
import Form, { InputField } from '../../../../components/form';
import * as yup from 'yup';
import { RadioField } from '../../../../components/form/radio-field';
import { _selectoptionType } from '../../../../components/form/select-field';
import styles from '../../styles.module.scss';
import { convertEnumsToOptions } from '../../../../utils';
import { ToggleFieldFormik } from '../../../../components/form/toggle-field-formik';
import { UserRoles } from '../../../../constants/enums';
import { Select } from 'antd';

const userFormSchema = yup.object({
    firstName: yup.string().required('This is a required field'),
    lastName: yup.string().required('This is a required field'),
    email: yup.string().email('Not a valid email').required('This is a required field'),
    role: yup.string(),
    userStatus: yup.boolean(),
    groups: yup.array()
});

export type UserFormValues = yup.InferType<typeof userFormSchema>

export type UserFormProps = {
    type: 'update' | 'readOnly';
    initialValues: any;
    submitButtons?: React.ReactNode;
    onSubmit?: (arg0: UserFormValues) => any;
    hideUserStatus?: boolean;
    groupsList?: any[];
}


const userRoleOptions: _selectoptionType[] = convertEnumsToOptions(UserRoles);

export const UserForm: React.FC<UserFormProps> = ({ onSubmit, type, initialValues, submitButtons, hideUserStatus = false, groupsList }) => {

    const [selectedGroups, setSelectedGroups] = useState<string[]>(
        initialValues?.groups?.length ? initialValues.groups.map((group:any) => group.id) : []
    );
    
    const handleFormSubmit = (values: UserFormValues) => {
        const selectedGroupObjects = (groupsList || [])
            .filter(group => selectedGroups.includes(group.id))
            .map(group => ({ id: group.id, name: group.name }));
    
        const updatedValues = { ...values, groups: selectedGroupObjects };
    
        onSubmit && onSubmit(updatedValues);
    };
    

    const initialValuesForForm: UserFormValues = useMemo(() => {
        return {
            ...initialValues,
            userStatus: initialValues?.enabled
        };
    }, [initialValues]);


    const readOnly = type === 'readOnly';

    return(
        <Form
            initialValues={initialValuesForForm}
            validationSchema={userFormSchema}
            onSubmit={handleFormSubmit}
            enableReinitialize
        >
            <div
                className={styles['userInfoForm']}
            >
                <InputField 
                    name="firstName"
                    label="First Name"
                    readOnly={readOnly}
                    required={!readOnly}
                />
                <InputField 
                    name="lastName"
                    label="Last Name"
                    readOnly={readOnly}
                    required={!readOnly}
                />
                <InputField 
                    name="email"
                    label="Email Address"
                    readOnly
                />
                <div>
                    <label className={styles["userStatusLabel"]}>Groups</label>
                    <Select
                        mode="multiple"
                        placeholder="Select groups"
                        value={selectedGroups} 
                        onChange={(value) => setSelectedGroups(value)}
                        style={{ width: "100%" }}
                        disabled={readOnly}
                    >
                        {groupsList?.map((group) => (
                            <Select.Option key={group.id} value={group.id}>
                                {group.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <RadioField
                    label="Role"
                    name="role" 
                    options={userRoleOptions}
                    readOnly={readOnly}
                    inline
                />
                {!hideUserStatus &&
                    <div>
                        <label className={styles['userStatusLabel']}>
                            User Status
                        </label>
                        <ToggleFieldFormik name="userStatus" label="Active" unSelectedLabel="Inactive" readOnly={readOnly}/>
                    </div>
                }
            </div>
            <br />
            {submitButtons && submitButtons}
        </Form>
    );
};